// // Define transition points between time periods (in degrees)
const DAWN_START = 60;
const DAY_START = 90;
const DUSK_START = 260;
const NIGHT_START = 300;
// Define mapbox light properties for each time period
const LIGHT_PROPERTIES = {
    dawn: {
        ambient: {
            intensity: 0.3,
            color: "hsl(206, 100%, 97%)",
        },
        directional: {
            intensity: 0.5,
            color: "hsl(33, 98%, 77%)",
        },
    },
    day: {
        ambient: {
            intensity: 0.5,
            color: "hsl(0, 0%, 100%)",
        },
        directional: {
            intensity: 0.8,
            color: "hsl(0, 0%, 100%)",
        },
    },
    dusk: {
        ambient: {
            intensity: 0.5,
            color: "hsl(228, 27%, 29%)",
        },
        directional: {
            intensity: 0.2,
            color: "hsl(30, 98%, 76%)",
        },
    },
    night: {
        ambient: {
            intensity: 0.5,
            color: "hsl(228, 27%, 29%)",
        },
        directional: {
            intensity: 0.2,
            color: "hsl(30, 98%, 76%)",
        },
    },
};
// Get the time period based on azimuth
const getTimePeriod = (azimuth) => {
    if (azimuth >= DAWN_START && azimuth < DAY_START)
        return "dawn";
    if (azimuth >= DAY_START && azimuth < DUSK_START)
        return "day";
    if (azimuth >= DUSK_START && azimuth < NIGHT_START)
        return "dusk";
    return "night";
};
/**
 *
 * @param azimuth
 * @returns all light properties for a given azimuth in degrees
 */
export const getLightProperties = (azimuth) => {
    return LIGHT_PROPERTIES[getTimePeriod(azimuth)];
};
